import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';

const Base = ({ children }) => {
  const [sidebar, setSidebar] = useState(false);

  return (
    <div className='wrapper' style={{ background: '#f4f4f4' }}>
      <Header onClickBars={() => setSidebar(!sidebar)} />
      <section className='body'>{children}</section>
    </div>
  );
};

Base.propTypes = {
  children: PropTypes.element
};

export default Base;
